import axios from "axios";
import { API_BASE } from "./config";

//const API_BASE = "http://localhost:80/api"; // Change to your PHP API URL

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json"
  }
});

// JWT handling
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  console.log('token', token);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
